export default __webpack_public_path__ + "static/media/Leggings of the Blood God.91c3425a.jpg";